import { Accordion } from '@mui/material';
import styled from 'styled-components';

import { colorTokens } from '../variables';

export const StyledAccordion = styled(Accordion)`
  &.MuiPaper-root {
    position: relative;
  }
  &.MuiPaper-elevation1 {
    box-shadow: none;
  }
  .MuiAccordionSummary-expandIconWrapper {
    width: 13px;
    > svg {
      color: ${colorTokens.secondary.main};
    }
  }
`;
